import { z } from "zod";

const emptyToUndefined = z.literal("").transform(() => undefined);
const coercedNumber = z.union([emptyToUndefined, z.coerce.number()]);

export const campaignThemeSchema = z.object({
  accent: z.string().min(1),
  background: z.string().min(1),
  foreground: z.string().min(1),
  icon: z.enum(["sparkles", "rocket", "gift"]).nullable(),
});

export const campaignFormSchema = z.object({
  name: z.string().min(1, "Name is required"),
  slug: z
    .string()
    .min(1, "Slug is required")
    .regex(/^[a-z0-9-]+$/, "Slug must be lowercase kebab-case"),
  bannerTitle: z.string().min(1, "Banner title is required"),
  bannerDescription: z.string().min(1, "Banner description is required"),
  bannerCtaText: z.string().min(1, "Banner CTA text is required"),
  bannerCtaUrl: z.string().min(1, "Banner CTA URL is required"),
  interstitialTitle: z.string().min(1, "Interstitial title is required"),
  interstitialDescription: z.string().min(1, "Interstitial description is required"),
  interstitialCtaText: z.string().min(1, "Interstitial CTA text is required"),
  interstitialCtaUrl: z.string().min(1, "Interstitial CTA URL is required"),
  emailSubject: z.string().min(1, "Email subject is required"),
  emailBody: z.string().min(1, "Email body is required"),
  theme: campaignThemeSchema,
  discountPercent: coercedNumber.pipe(z.number().int().min(1).max(100).optional()),
  discountDurationMonths: coercedNumber.pipe(z.number().int().positive().optional()),
  targetTiers: z
    .array(z.enum(["FREE", "BASIC", "PRO", "PRO_PLUS"]))
    .min(1, "Select at least one tier"),
  startDate: z.union([emptyToUndefined, z.string().min(1)]).optional(),
  endDate: z.union([emptyToUndefined, z.string().min(1)]).optional(),
  isActive: z.boolean(),
  priority: coercedNumber.pipe(z.number().int()),
});

export type CampaignFormInput = z.input<typeof campaignFormSchema>;
export type CampaignFormOutput = z.output<typeof campaignFormSchema>;
